import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getSubjectsOrganizationLevels($id: String!) {
    getParentHierarchy(id: $id) {
      items {
        organization {
          name
        }
        level {
          name
        }
      }
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.OrganizationHierarchyListState = {
  result: null,
  error: null,
  loading: false
};

export const getSubjectsOrganizationLevelsRequest = createAsyncThunk<
  TYPES.OrganizationHierarchyList,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/get_subjects_organization_levels',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getParentHierarchy;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getSubjectsOrganizationLevelsSlice = createSlice({
  name: 'get_subjects_organization_levels',
  initialState: initialState,
  reducers: {
    getSubjectsOrganizationLevelsClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getSubjectsOrganizationLevelsRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      getSubjectsOrganizationLevelsRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      getSubjectsOrganizationLevelsRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { getSubjectsOrganizationLevelsClear } =
getSubjectsOrganizationLevelsSlice.actions;

export const getSubjectsOrganizationLevels = createSelector(
  (state: RootState) =>
  state.organization.getSubjectsOrganizationLevels.result,
  (state: RootState) =>
  state.organization.getSubjectsOrganizationLevels.error,
  (state: RootState) =>
  state.organization.getSubjectsOrganizationLevels.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getSubjectsOrganizationLevelsSlice.reducer;